module.exports = {
  App: {
    name: 'Name',
  }
}